module.exports = __webpack_public_path__ + "img/icon-limbs-title.a5aaa77d.png";